import { IoSearchOutline } from 'react-icons/io5'
import { vccBtn } from '@shared/ui/vccButtons'
import { vccButtonLabel, type VccActionButtonProps } from './vccButtonProps'

export type SearchButtonProps = VccActionButtonProps

export default function SearchButton({
  onClick,
  disabled,
  type = 'button',
  className = '',
  showIcon = true,
  loading = false,
  loadingLabel = 'Searching...',
  label = 'Search',
  children,
  ...rest
}: SearchButtonProps) {
  return (
    <button
      type={type}
      className={`${vccBtn('search')} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled || loading}
      {...rest}
    >
      {showIcon && !loading && <IoSearchOutline aria-hidden className="vcc-btn__icon" />}
      {vccButtonLabel({ children, label, loading, loadingLabel }, label)}
    </button>
  )
}
